module.exports = __webpack_public_path__ + "img/BridgerClayton.3fb3ce91.png";